import { useEffect, useRef } from "react";
import { submitUsageEvents } from "../../api/client";
import { useApp } from "../../context/AppContext";
import type { MainTab } from "../../models/types";

function screenForTab(tab: MainTab): string {
  return tab;
}

export function UsageTracker() {
  const { session, isUnlocked, activeTab } = useApp();
  const openedRef = useRef(false);

  useEffect(() => {
    if (!session || !isUnlocked || openedRef.current) return;
    openedRef.current = true;
    void submitUsageEvents(session, [
      { event_name: "app_open", screen: "home", client_ts: Math.floor(Date.now() / 1000) },
    ]).catch(() => {
      /* best effort */
    });
  }, [session, isUnlocked]);

  useEffect(() => {
    if (!session || !isUnlocked) return;
    void submitUsageEvents(session, [
      {
        event_name: "screen_view",
        screen: screenForTab(activeTab),
        client_ts: Math.floor(Date.now() / 1000),
      },
    ]).catch(() => {
      /* best effort */
    });
  }, [session, isUnlocked, activeTab]);

  return null;
}
